import { Pipe, PipeTransform } from '@angular/core';
import { airspaceAuthorisationTypeList } from '@flyfreely-portal-ui/flyfreely';
import { setupStatusFormatter } from '../helpers';

@Pipe({ name: 'formatAuthorisationType' })
export class FormatAirspaceAuthorisationTypePipe implements PipeTransform {
    transform: (value: any, ...args: any[]) => any;

    constructor() {
        this.transform = setupStatusFormatter(airspaceAuthorisationTypeList);
    }
}
